import * as React from "react";

import { IconSort } from "@common/components/Atoms/Icons";

/*===========================================================================
  TODO: match icon directions to sort type since no direction toggle
/*======================================================================== */

/*
    CreateTimestamp = 0,DESC
    Job = 1,
    Location = 2,
    Status = 3,
    TeamName = 4,
    QuantityMinusHiredJobCandidateCount = 5,DESC
    NewJobCandidateCount = 6,DESC
    QualifyingJobCandidateCount = 7,DESC
    ReviewJobCandidateCount = 8,DESC
    SubmittedJobCandidateCount = 9,DESC
    InterviewingJobCandidateCount = 10,DESC
    OfferedJobCandidateCount = 11,DESC
    RejectedJobCandidateCount = 13,DESC
    HiredJobCandidateCount = 14,DESC
    Relevance = 15,DESC
    Priority = 16
  */

function getDirectionFromKey(sortKey): "desc" | "asc" {
    const ascendingSortKeys = [1, 2, 3, 4, 16, 17, 18];

    if (ascendingSortKeys.indexOf(sortKey) !== -1) {
        return "asc";
    }

    return "desc";
}

/*===========================================================================
  Sort
/*======================================================================== */
interface SortProps {
    children: React.ReactNode
    onSortChange: () => void
    sortKey: number,
    orderBy: number
}

export const Sort = (props: SortProps) => {
    const classes = ["c-sort"];
    const isSelected = props.sortKey === props.orderBy;
    if(isSelected) classes.push("is-selected");

    return (
        <div
            className={classes.join(" ")}
            onClick={props.onSortChange}
            data-sortkey={props.sortKey}>
            <span className="c-sort__label">{props.children}</span>
            <span className="c-sort__direction">
                <IconSort direction={getDirectionFromKey(props.sortKey)} />
            </span>
        </div>
    );
};

export default Sort;
